import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import IUpdateFrecuency from "../interfaces/IUpdateFrecuency";
import { GetUpdateFrecuencys } from "../services/list";


const useListFrecuenciaActulizacion = () => {

    // States
    const [listFrecuency, setListFrecuency] = useState<IUpdateFrecuency[]>([]);
    const [loadingListFrecuency, setLoadingListFrecuency] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetUpdateFrecuencys();
    }, [])

    // Handles
    const handleGetUpdateFrecuencys = () => {
        setLoadingListFrecuency(true);
        tryCatch(() => {
            GetUpdateFrecuencys()
                .then((response) => {
                    setListFrecuency(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingListFrecuency(false));
        })
    }

    return {
        listFrecuency,
        loadingListFrecuency
    }
}


export default useListFrecuenciaActulizacion;
